import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import DownloadingOutlinedIcon from '@mui/icons-material/DownloadingOutlined';
import '../studyDocuments/studyDocumnent.css'


function ActiveStudyDocumentForUser({ setShowSpinner, studyData }) {
    const handleDocumentClick = (document) => {
        console.log("Opening document:", document); // Log for debugging
        window.open(document, '_blank');
    };
    const extractAdminDocuments = (data) => {
        return data.flatMap(item => {
            const adminDocuments = [];

            // Check each step for an adminDocument
            for (let i = 1; i <= 7; i++) {
                const stepKey = `step${i}`;
                if (item[stepKey] && item[stepKey].adminDocument) {
                    adminDocuments.push(item[stepKey].adminDocument);
                }
            }

            return adminDocuments;
        });
    };

    const [pdfUrls, setPdfUrls] = useState(extractAdminDocuments(studyData));

    return (
        <div className='p-4'>
            <div className='row d-flex align-items-center'>
                {pdfUrls.map((doc, index) => {
                    let fileType = doc.split('/')[pdfUrls[0].split('/').length - 2];
                    if (doc.split('/')[pdfUrls[0].split('/').length - 2] === "Protocol/FQ") {
                        fileType = "Protocol";
                    } else if (doc.split('/')[pdfUrls[0].split('/').length - 2] === "Budget/CTA") {
                        fileType = "Budget";
                    }
                    return (
                        <Box
                            key={index}
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                mx: 1,
                                p: 2,
                                mb:2,
                                borderRadius: '4px',
                                width: '300px',
                                height: '50px',
                                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                                cursor: 'pointer',
                            }}
                            onClick={() => handleDocumentClick(doc)}
                        >
                            <h4 style={{ color: 'rgb(23 131 131)' }}>{fileType}</h4>
                <h4 style={{ color: 'rgb(23 131 131)', cursor: 'pointer' }}> <DownloadingOutlinedIcon /></h4>
                        </Box>
                    )
                })}
            </div>
        </div>
    )
}

export default ActiveStudyDocumentForUser